import React from 'react';
import { Link } from 'react-router-dom';
import { useTrialOffer } from '@shared/ui/lib/useTrialOffer';

interface LoginPromptProps {
  message?: string;
}

const LoginPrompt: React.FC<LoginPromptProps> = () => {
  // Only promise a free trial while the trial package gives one
  const { trialDays } = useTrialOffer();
  return (
    <div className="bg-gradient-to-br from-deep-navy to-deep-navy-light px-6 py-12 text-center">
      <p className="text-racing-green-light text-sm font-semibold uppercase tracking-wider mb-3">
        Join thousands of smart punters
      </p>
      <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3">
        Ready to start backing smarter?
      </h2>
      <p className="text-gray-400 mb-8 max-w-md mx-auto">
        {trialDays
          ? 'Full access to every race, every track — with no credit card required for your free trial.'
          : 'Create your free account, then choose the plan or pass that suits you. No credit card to join.'}
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link
          to="/register"
          className="bg-race-gold text-deep-navy px-8 py-3 rounded-md font-bold hover:bg-race-gold-dark transition-colors text-lg"
        >
          {trialDays ? 'Start Your Free Trial' : 'Join Free'}
        </Link>
        <Link
          to="/login"
          className="bg-white/10 border border-white/30 text-white px-8 py-3 rounded-md font-bold hover:bg-white/20 transition-colors text-lg"
        >
          Log In
        </Link>
      </div>
    </div>
  );
};

export default LoginPrompt;